import { render } from "./ResumenTopObsEstandar.vue?vue&type=template&id=4e738e02&scoped=true"
import script from "./ResumenTopObsEstandar.vue?vue&type=script&lang=js"
export * from "./ResumenTopObsEstandar.vue?vue&type=script&lang=js"

import "./ResumenTopObsEstandar.vue?vue&type=style&index=0&id=4e738e02&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e738e02"]])

export default __exports__